var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36445 15.4645C6.30213 14.5268 7.5739 14 8.89999 14H16.9C18.2261 14 19.4978 14.5268 20.4355 15.4645C21.3732 16.4021 21.9 17.6739 21.9 19V21C21.9 21.5523 21.4523 22 20.9 22C20.3477 22 19.9 21.5523 19.9 21V19C19.9 18.2044 19.5839 17.4413 19.0213 16.8787C18.4587 16.3161 17.6956 16 16.9 16H8.89999C8.10434 16 7.34128 16.3161 6.77867 16.8787C6.21606 17.4413 5.89999 18.2044 5.89999 19V21C5.89999 21.5523 5.45227 22 4.89999 22C4.3477 22 3.89999 21.5523 3.89999 21V19C3.89999 17.6739 4.42677 16.4021 5.36445 15.4645Z",
    fill: "#676D75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9 4C11.2431 4 9.89999 5.34315 9.89999 7C9.89999 8.65685 11.2431 10 12.9 10C14.5568 10 15.9 8.65685 15.9 7C15.9 5.34315 14.5568 4 12.9 4ZM7.89999 7C7.89999 4.23858 10.1386 2 12.9 2C15.6614 2 17.9 4.23858 17.9 7C17.9 9.76142 15.6614 12 12.9 12C10.1386 12 7.89999 9.76142 7.89999 7Z",
    fill: "#676D75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconMenu);
export default __webpack_public_path__ + "static/media/profile-icon-menu.35ec58633081c2108dd8af1544644764.svg";
export { ForwardRef as ReactComponent };